import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { Text } from "../../../../../components/Text";
import { ConversationComment } from "../../../../../model/integration/dto/meta/MetaConversationComment";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";
import { WAUserAvatar } from "../components/WAUserAvatar";
import { WA_COMMENT_CHIP_HEIGHT } from "./WACommentPriorityTag";

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: ${WA_COMMENT_CHIP_HEIGHT};
  gap: ${Spacing.xs};
  /* Tight on the avatar's side, so the picture sits inside the pill's curve */
  padding-inline: 0.125rem ${Spacing.s};
  border-radius: ${Rounded.pill};
  border: 1px solid ${({ theme }) => theme.success};
  white-space: nowrap;
`;

type Props = {
  comment: ConversationComment;
};

/** Who resolved a comment: their picture, their name and a tick. Once their
 * account is gone only the tick and "Resolved" are left to show.
 */
export const WACommentResolvedChip: React.FC<Props> = ({ comment }) => {
  const { t } = useTranslation();

  const name = comment.resolvedBy?.name;

  return (
    <Chip
      title={
        name
          ? t("integration.whatsapp.meta.comments.resolvedBy", { name })
          : t("integration.whatsapp.meta.comments.resolved")
      }
    >
      {name ? (
        <WAUserAvatar user={comment.resolvedBy!} size="1.125rem" />
      ) : null}
      <Text fontSize="xs">
        {name || t("integration.whatsapp.meta.comments.resolved")}
      </Text>
      <AtiraIcon icon={faCheckCircle} size="xs" color="success" />
    </Chip>
  );
};
